function replaceSearchParams(url: URL): void {
  // eslint-disable-next-line no-restricted-syntax
  history.replaceState(null, '', url)
  window.dispatchEvent(new Event('replacestate'))
}

export { replaceSearchParams }
